import { publicPath } from './publicPath';

export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = publicPath('/sw.js');
    void navigator.serviceWorker.register(swUrl);
  });
}
